import { request } from './config/utils'

import { Params } from '../../constants'

export function myNotificationsPostRequest(params) {

    return request('post', params, Params.MY_NOTIFICATIONS_POST)
}